// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
  position: relative;
  display: inline-block;
  margin-left: 2px;
  width: 60px;
  height: 20px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #8B0000;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 0px;
  bottom: 1px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #00008B;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00008B;
}

input:checked + .slider:before {
  transform: translateX(41px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.sidebar {
    margin: 0;
    padding: 0;
    width: 200px;
    background-color: #f1f1f1;
    margin: 10Px;
    position: absolute;
    height: auto;
    overflow: auto;
  }
  
  .compareElLan:nth-of-type(odd){
    background-color:#FFFFFF;
  }
  .compareElLan:nth-of-type(even){
    background-color:#FFF5EE;
  }
  
  .compareElLan:nth-of-type(odd) textarea {
    background-color:#FFFFFF;
  }
  .compareElLan:nth-of-type(even) textarea {
    background-color:#FFF5EE;
  }

  .compareElLan:nth-of-type(odd) input{
    background-color:#FFFFFF;
  }
  .compareElLan:nth-of-type(even) input{
    background-color:#FFF5EE;
  }

  .compareElLan:nth-of-type(odd) p{
    background-color:#FFFFFF;
  }
  .compareElLan:nth-of-type(even) p{
    background-color:#FFF5EE;
  }  
  
  .compareElLan:nth-of-type(odd) li{
    background-color:#FFFFFF;
  }
  .compareElLan:nth-of-type(even) li{
    background-color:#FFF5EE;
  }
  .sidebar a {
    display: block;
    color: black;
    padding: 16px;
    text-decoration: none;
  }
   
  .sidebar a.active {
    background-color: #9ed9e0;
    color: white;
  }
  
  .sidebar a:hover:not(.active) {
    background-color: #555;
    color: white;
  }
  
 div.content {
  margin-left: 200px;
  padding: 1px 16px;
  min-height: 1000px;
  box-sizing: border-box;
  width: calc(100% - 200px);
}
  
  @media screen and (max-width: 700px) {
    .sidebar {
      width: 100%;
      height: auto;
      position: relative;
    }
    .sidebar a {float: left;}
 div.content {
    margin-left: 0;
    width: 100%;
  }
  }
  
  @media screen and (max-width: 400px) {
    .sidebar a {
      text-align: center;
      float: none;
    }
  }`, "",{"version":3,"sources":["webpack://./src/includes/pages/AddLanguage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EAEzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;CAED;EACC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;EAEE;IACE;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;IACA,YAAY,WAAW,CAAC;CAC3B;IACG,cAAc;IACd,WAAW;EACb;EACA;;EAEA;IACE;MACE,kBAAkB;MAClB,WAAW;IACb;EACF","sourcesContent":[".switch {\n  position: relative;\n  display: inline-block;\n  margin-left: 2px;\n  width: 60px;\n  height: 20px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #8B0000;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 0px;\n  bottom: 1px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #00008B;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #00008B;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(41px);\n  -ms-transform: translateX(41px);\n  transform: translateX(41px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.sidebar {\n    margin: 0;\n    padding: 0;\n    width: 200px;\n    background-color: #f1f1f1;\n    margin: 10Px;\n    position: absolute;\n    height: auto;\n    overflow: auto;\n  }\n  \n  .compareElLan:nth-of-type(odd){\n    background-color:#FFFFFF;\n  }\n  .compareElLan:nth-of-type(even){\n    background-color:#FFF5EE;\n  }\n  \n  .compareElLan:nth-of-type(odd) textarea {\n    background-color:#FFFFFF;\n  }\n  .compareElLan:nth-of-type(even) textarea {\n    background-color:#FFF5EE;\n  }\n\n  .compareElLan:nth-of-type(odd) input{\n    background-color:#FFFFFF;\n  }\n  .compareElLan:nth-of-type(even) input{\n    background-color:#FFF5EE;\n  }\n\n  .compareElLan:nth-of-type(odd) p{\n    background-color:#FFFFFF;\n  }\n  .compareElLan:nth-of-type(even) p{\n    background-color:#FFF5EE;\n  }  \n  \n  .compareElLan:nth-of-type(odd) li{\n    background-color:#FFFFFF;\n  }\n  .compareElLan:nth-of-type(even) li{\n    background-color:#FFF5EE;\n  }\n  .sidebar a {\n    display: block;\n    color: black;\n    padding: 16px;\n    text-decoration: none;\n  }\n   \n  .sidebar a.active {\n    background-color: #9ed9e0;\n    color: white;\n  }\n  \n  .sidebar a:hover:not(.active) {\n    background-color: #555;\n    color: white;\n  }\n  \n div.content {\n  margin-left: 200px;\n  padding: 1px 16px;\n  min-height: 1000px;\n  box-sizing: border-box;\n  width: calc(100% - 200px);\n}\n  \n  @media screen and (max-width: 700px) {\n    .sidebar {\n      width: 100%;\n      height: auto;\n      position: relative;\n    }\n    .sidebar a {float: left;}\n div.content {\n    margin-left: 0;\n    width: 100%;\n  }\n  }\n  \n  @media screen and (max-width: 400px) {\n    .sidebar a {\n      text-align: center;\n      float: none;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
